export class PurchaseRequestBO {
  id: string | null;
  clientId: string;
  clientName: string;
  requestDate: string;
  clientAuthorizationId: string;
  payerId: string;
  payerName: string;
  serviceId: string;
  serviceName: string;
  item: string;
  description: string;
  quantity: number;
  rate: number;
  totalAmount: any;
  statusDate: string;
  purchaseTypeLid: string;
  purchaseTypeName: string;
  vendorId: string | null;
  vendorName: string;
  purchaseReceiptId: string | null;
  returnDocument: string;
  lastUpdatedDate: string;
  requestStatusLid: string;
  requestStatusName: string;
  attachMent: File;
  purchaseReceipts: PurchaseReceiptBO;
  fileName:string;
 

}

export class PurchaseReceiptBO {
  containerName: string;
  filePath: any;
  fileName: string;
}

export class AuthForPurchaseBO {
  startDate: string | null;
  endDate: string | null;
  serviceId: string;
  clientAuthorizationId: string;
  payerId: string;
  payerName: string;
  serviceName: string;
  serviceDescription: string;
  toTalAmount: number;
  usedAmount: number;
  insuranceNumber:string;
  authNote: string;
}

export class GetPurchaseBase {
  clientId: string | null;
  purchaseTypeLid: string | null;
  requestStatusLid: string | null;
  serviceId: string | null;
  locationID: string | null;
  agencyID: string | null;
  currentpageno: number = 1;
  pageitem: number = 10;
  orderColumn: string = "clientName";
  orderType: string = "asc";
  type: string = "string";
  field: string = "clientName";
  operator: string = "startswith";
  value: string = "";
  matchCase: boolean = false;
}

export class servicedropdown {
  key: string;
  value: string;
}
// export class FormFile {
//   contentType: string;
//   contentDisposition: string;
//   headers: any;
//   length: number;
//   name: string;
//   fileName: string;
// }

export class purchaseBo {
  clientid: string;
  clientName: string;
  clientToPurchase: boolean = false;
}


export class VendorBO {
  id: string="00000000-0000-0000-0000-000000000000";
  name: string;
  companyName: string;
  email: string;
  phone: string;
  street: string;
  city: string;
  state: string;
  zipCode: string;
  statusLid: string;
  statusLovName: string;
  taxId: string;
  agencyId: string;
}

export class functionpermission{
  clientpurchasecreate:boolean=true;
  purchasereqapprove:boolean=true;
  purchasereqreject:boolean=true;

}


